import { createEnv } from "@t3-oss/env-nextjs";
import z from "zod";

export const env = createEnv({
  shared: {
    NODE_ENV: z
      .enum(["development", "production", "test"])
      .default("development"),
  },
  server: {
    FOD_API_URL: z.url(),
    ANDROID_APP_URL: z.url(),
    IOS_APP_URL: z.url(),
    LOG_LEVEL: z
      .enum(["fatal", "error", "warn", "info", "debug", "trace", "silent"])
      .optional(),
    NEXT_RUNTIME: z.enum(["nodejs", "edge"]).optional(),
    BASIC_AUTH_USER: z.string().optional(),
    BASIC_AUTH_PASSWORD: z.string().optional(),
  },
  // NEXT_PUBLIC_*_APP_URL は ANDROID_APP_URL / IOS_APP_URL と同じ値を設定する。
  // error.tsx がクライアントコンポーネント必須のため別名で追加。
  // 将来的に ANDROID_APP_URL / IOS_APP_URL との統合を検討すること。
  client: {
    NEXT_PUBLIC_ANDROID_APP_URL: z.url(),
    NEXT_PUBLIC_IOS_APP_URL: z.url(),
  },
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    FOD_API_URL: process.env.FOD_API_URL,
    ANDROID_APP_URL: process.env.ANDROID_APP_URL,
    IOS_APP_URL: process.env.IOS_APP_URL,
    NEXT_PUBLIC_ANDROID_APP_URL: process.env.NEXT_PUBLIC_ANDROID_APP_URL,
    NEXT_PUBLIC_IOS_APP_URL: process.env.NEXT_PUBLIC_IOS_APP_URL,
    LOG_LEVEL: process.env.LOG_LEVEL,
    NEXT_RUNTIME: process.env.NEXT_RUNTIME,
    BASIC_AUTH_USER: process.env.BASIC_AUTH_USER,
    BASIC_AUTH_PASSWORD: process.env.BASIC_AUTH_PASSWORD,
  },
});

export const isDev = env.NODE_ENV === "development";
